
<template>
<div class="wrapper">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
              <Map
              :dataArray = "filteredMapArray"
              appId="r3da84nDNIcneFJcNZKs"
              appCode="fKYR0EKFlaGeC8CDzbuL_w"
              width="100%"
              zoom = ""
              height="600px" />
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Map from '@/components//Map/Map'
import moment from 'moment'
export default {
  name: 'MapView',
  components: {
    Map,
    moment
  },
  data () {
    return {
      trucks: '',
      dataArray: [],
      filteredMapArray: [],
      timer: '',
      userCustomerId: null,
      role: ''
    }
  },
  async created () {
    if (localStorage.getItem('userCustomerId')) {
      this.userCustomerId = localStorage.getItem('userCustomerId')
    }
    this.role = localStorage.getItem('role')
    await this.getTrucks()
    this.timer = setInterval(async () => {
      await this.getTrucks()
    }, 30000)
  },
  methods: {
    async getTrucks () {
      let apiCall = '/api/orders/by-active'
      if (this.userCustomerId !== null && this.userCustomerId !== 'null') {
        apiCall = '/api/orders/by-active/' + this.userCustomerId
      }
      this.$http
        .get(apiCall)
        .then(async response => {
          var orders = response.data
          orders.forEach(async (order) => {
            if (order.data.trucks) {
              for (var i = 0; i < order.data.trucks.length; i++) {
                let lastOrderRow = ''
                let logData = '<div class="logData"><strong>Logg</strong><ul>'
                let filteredOrderRows = order.data.orderRows.filter((c) => c.truckId === order.data.trucks[i].id)
                if (filteredOrderRows.length > 0) {
                  lastOrderRow = filteredOrderRows.slice(-1)[0]
                  var activeState = lastOrderRow.actions.slice(-1)[0].name
                  let driverName = lastOrderRow.driverName
                  for (var b = 0; b < lastOrderRow.actions.length; b++) {
                    var startTime = moment(lastOrderRow.actions[b].startTime).format('MM-DD HH:mm')
                    var endTime = ''
                    if (lastOrderRow.actions[b].endTime) {
                      endTime = '<br/>' + moment(lastOrderRow.actions[b].endTime).format('MM-DD HH:mm')
                      activeState = 'Utförs'
                    }
                    logData = logData + '<li><span>' + startTime + endTime + '</span><span>' + lastOrderRow.actions[b].name + '</span></li>'
                  }
                  var destination = ''
                  if (order.data.DeliveryPlaceCity) {
                    destination = order.data.DeliveryPlaceCity
                  } else if (order.data.CustomerPlaces) {
                    destination = order.data.CustomerPlaces[0].data.name
                  } else {
                    destination = order.data.customerPlaceName
                  }
                  logData = logData + '</ul></div>'
                  let Data = '<div class="mapInfoWrapper"><strong>' + order.data.trucks[i].name + '</strong><ul><li><span>Ordernr</span><span>' + order.id + '</span></li><li><span>Destination</span><span>' + destination + '</span></li><li><span>Chaufför</span><span>' + driverName + '</span></li></ul>' + logData + '</div>'
                  let responseTruck = await this.$http.get('/api/objectdatasWithGPS/' + order.data.trucks[i].id)
                  var latestGpsLoc = responseTruck.data.GpsPositions.slice(-1)[0]
                  let truckObj = { State: activeState, OrderType: order.type, Name: order.data.trucks[i].name, Driver: driverName, Order: order, OrderId: order.id, Destination: destination, Latitude: latestGpsLoc.lat, Longitude: latestGpsLoc.lon, Title: order.data.trucks[i].name, Data: Data }
                  let isAlreadyAddedObject = this.dataArray.find(x => x.Name === truckObj.Name)
                  let isAlreadyAddedObjectFilter = this.filteredMapArray.find(x => x.Name === truckObj.Name)
                  if (isAlreadyAddedObject) {
                    isAlreadyAddedObject.Latitude = latestGpsLoc.lat
                    isAlreadyAddedObject.Longitude = latestGpsLoc.lon
                    isAlreadyAddedObjectFilter.Latitude = latestGpsLoc.lat
                    isAlreadyAddedObjectFilter.Longitude = latestGpsLoc.lon
                    this.filteredMapArray.push(...truckObj)
                  } else {
                    this.dataArray.push(truckObj)
                    this.filteredMapArray.push(truckObj)
                  }
                }
              }
            } else {
              let logData = '<div class="logData"><strong>Logg</strong><ul>'
              let truckName = ''
              let driverName = ''
              if (order.data.orderRows) {
                let orderRow = order.data.orderRows[0]
                truckName = order.data.orderRows[0].truckName
                driverName = order.data.orderRows[0].driverName
                var activeState2 = orderRow.actions.slice(-1)[0].name
                for (var c = 0; c < orderRow.actions.length; c++) {
                  var startTime2 = moment(orderRow.actions[c].startTime).format('MM-DD HH:mm')
                  var endTime2 = ''
                  if (orderRow.actions[c].endTime) {
                    endTime2 = '<br/>' + moment(orderRow.actions[c].endTime).format('MM-DD HH:mm')
                    activeState2 = 'Utförs'
                  }
                  logData = logData + '<li><span>' + startTime2 + endTime2 + '</span><span>' + orderRow.actions[c].name + '</span></li>'
                }
              }
              var destination2 = ''
              if (order.data.DeliveryPlaceCity) {
                destination2 = order.data.DeliveryPlaceCity
              } else {
                destination2 = order.data.customerPlaceName
              }
              logData = logData + '</ul></div>'
              let Data = '<div class="mapInfoWrapper"><strong>' + truckName + '</strong><ul><li><span>Ordernr</span><span>' + order.id + '</span></li><li><span>Destination</span><span>' + destination2 + '</span></li><li><span>Chaufför</span><span>' + driverName + '</span></li></ul>' + logData + '</div>'
              let responseTruck2 = await this.$http.get('/api/objectdatasWithGPS/' + order.data.truck)
              var latestGpsLoc2 = responseTruck2.data.GpsPositions.slice(-1)[0]
              let truckObj = { State: activeState2, OrderType: order.type, Name: truckName, Driver: driverName, Order: order, OrderId: order.id, Destination: destination, Latitude: latestGpsLoc2.lat, Longitude: latestGpsLoc2.lon, Title: truckName, Data: Data }
              let isAlreadyAddedObject = this.dataArray.find(x => x.OrderId === order.id)
              let isAlreadyAddedObjectFilter = this.filteredMapArray.find(x => x.OrderId === order.id)
              if (isAlreadyAddedObject) {
                isAlreadyAddedObject.Latitude = latestGpsLoc2.lat
                isAlreadyAddedObject.Longitude = latestGpsLoc2.lon
                isAlreadyAddedObjectFilter.Latitude = latestGpsLoc2.lat
                isAlreadyAddedObjectFilter.Longitude = latestGpsLoc2.lon
                this.filteredMapArray.push(...truckObj)
              } else {
                this.dataArray.push(truckObj)
                this.filteredMapArray.push(truckObj)
              }
            }
          })
        })
    },
    cancelAutoUpdate () { clearInterval(this.timer) }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MapView.vue